var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"text-center"},[_c('h5',{staticClass:"h5-footer"},[_c('span',{staticClass:"footer-text"},[_vm._v("Copyright © 2021 GBS Architectural Srl | Powered by")]),_vm._v(" Filevel Software ®")])])}
var staticRenderFns = []

export { render, staticRenderFns }